import { CSSProperties, FC } from "react";
import { FlagIcon } from "@/ui";

/**
 * Renders a course's emoji icon, swapping the flag emoji that break on
 * Windows/Chrome (🇪🇸 → bare "ES", 🇬🇧/🇺🇸 → "GB"/"US") for the SVG FlagIcon.
 * The course icon defaults to 🇪🇸 (mapCoursesToDisplayCourse) whenever a title
 * has no emoji, so most cards hit this path. Non-flag emoji (📚, 🪞, …) render
 * fine cross-platform, so they pass through unchanged.
 */
const ES_FLAG = "🇪🇸";
const UK_FLAGS = new Set(["🇬🇧", "🇺🇸"]); // English is shown as the UK flag app-wide

const CourseIcon: FC<{
  emoji: string;
  size?: "small" | "medium" | "large";
  className?: string;
  style?: CSSProperties;
}> = ({ emoji, size = "medium", className, style }) => {
  if (emoji === ES_FLAG)
    return (
      <FlagIcon countryCode="ES" size={size} className={className} style={style} />
    );
  if (UK_FLAGS.has(emoji))
    return (
      <FlagIcon countryCode="UK" size={size} className={className} style={style} />
    );
  return (
    <span className={className} style={style}>
      {emoji}
    </span>
  );
};

export default CourseIcon;
